module.exports = __webpack_public_path__ + "img/facts-all_1975.4a1845ea.png";